<template>
<div>
    <bar-manut
        single-entity="Grade"
        plural-entity="Grade"
        :crud="this.crud"
        :btn-delete="true"
        @closeform="closeForm"
        @delete="handleDelete"
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="grade.codgrade" :metadata="metadata.grade.codgrade" type="text" col="3" :disabled="true"></form-field>

                <form-field ref="descricao" v-model="grade.descricao" type="text" col="6" :metadata="metadata.grade.descricao"
                    case="normal" name="descricao" :v-errors="errors" v-validate="metadata.grade.descricao.validator"></form-field>
            </div>

            <label-title title="Variáveis" class="nb-margin-bottom nb-margin-top"></label-title>
            <div>
                <div v-for="(valor, index) in gradeit" :key="index">
                    <div :class="[{ 'mark-red': valor.duplicate }]"></div>
                    <div class="box">
                        <div class="col" v-if="valor.duplicate">
                                <small class="error">Variável duplicada não permitido</small>
                        </div>
                        <div class="col" v-if="valor.validate">
                                <small class="error">{{valor.validate}}</small>
                        </div>

                        <div class="row align-items-center">
                            <!-- <form-field ref="codigo" v-model="valor.codigo" type="text" col="2" label="Código"></form-field> -->
                            <form-field ref="descricaoit" v-model="valor.descricao" type="text" col="4" label="Descrição"></form-field>
                            <form-field ref="corit" v-model="valor.cor" type="color" col="2" label="Cor"
                                   :v-errors="errors" v-validate="{}"></form-field>
                            <form-field ref="seqit" v-model="valor.seq" type="number" col="2" label="Sequência"></form-field>
                            <div class="col-md-1 col-2">
                                <v-button v-if="!valor.vinculos > 0" label="" title="Excluir Variável" icon="fa-trash" @click="handleDeleteVariavel(index)"></v-button>
                            </div>
                            <div class="col-md-2 col-4">
                                <span v-if="valor.vinculos > 0" class="badge badge-gray">Produtos vinculados nesta variável: {{ valor.vinculos }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row nb-margin-top">
                    <div class="col-md-12 col-12">
                        <v-button label="Adicionar Variável" title="" :nb-btdef="true" @click="handleAdicionaVariavel"></v-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    components: {
    },

    data() {
        return {
            crudText: '',
            grade: {...this.$store.getters.getEntities.grade},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            gradeit: [],
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    watch: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.grade.codgrade)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid || this.variavelValidate()) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            this.apiDelete()
        },

        handleAdicionaVariavel () {
            //adiciona nova linha na tabela de unidade de medida do item
            var p = { codigo: '', descricao: '' }
            this.gradeit.push(p);

            let index = this.gradeit.length - 1

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
                this.$refs.descricaoit[index].focus()
            })
        },

        handleDeleteVariavel (index) {
            this.gradeit.splice(index,1)
        },

        variavelValidate () {
            //checa se foi digitado variáveis repetidas
            let test = {}
            //cria novo objeto array para fazer a veiricacao de duplicidades
            let valorArr = this.gradeit.map(function (obj) {
                return { descricao: obj.descricao }
            })
            //efetua a verificacao da duplicidade
            let duplicate = false
            let validate = ''
            for (var x = 0; x < valorArr.length; x++) {
                test = valorArr[x]
                this.$set(this.gradeit[x], 'duplicate', false)
                if (valorArr.findIndex(obj => obj.descricao == test.descricao) < x) {
                    this.gradeit[x].duplicate = true
                    duplicate = true
                }
                if (this.gradeit[x].descricao == null || this.gradeit[x].descricao == '') {
                    validate = 'Obrigatório informar a descrição'
                    this.$set(this.gradeit[x], 'validate', validate)
                } else {
                    this.$set(this.gradeit[x], 'validate', '')
                }
            }
            return (duplicate || (validate != ''))
        },


        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadGrade', { id: this.index } )
            if (this.$store.getters.getGrade) {
                this.grade = {...this.$store.getters.getGrade}
                // this.gradeit = JSON.parse(this.grade.valores)
                this.gradeit = this.grade.gradeit
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/grade/' + this.grade.codgrade

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/grade/'
            this.grade.gradeit = this.gradeit
            var sendData = { grade: this.grade }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/grade-form.vue